import React, { Component } from 'react';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Form from './components/Form';
import Table from '../../components/StatsTable';
import Graph from './components/Graph';
import API from '../../services/API';
import {NAN_PARAMS, PARAMS_NAME} from "./config";

class Pushapi extends Component {
    constructor() {
        super();

        this.state = {
            affidValues: [],
            subidValues: [],
            params: [],
            paramsObj: {},
            report: [],
            graph: [],
            total: {},
            isLoading: false
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }


    handleSubmit(filters, type) {
        this.setState({ isLoading: true });

        if(type === 'subid') return this.loadSubids(filters);

        this.loadReport(filters, type);
    }

    loadReport(filters, type) {
        Promise.all([
            API.PushapiV2.get(filters, type),
            API.PushapiV2.get(filters, 'graph')
        ])
            .then(([ { params, report, total }, { graph } ]) => {
            const paramsObj = params.reduce((obj, param, index) => {
                obj[param] = index;

                return obj;
            }, {});
            const newState = { params, paramsObj, report, total, graph, isLoading: false };

            if(type === 'affid') {
                const affidIndex = paramsObj['affid'];
                newState.affidValues = report.map(row => row[affidIndex]);
            }

            this.setState(newState)
        })
    }

    loadSubids(filters) {
        API.PushapiV2.get(filters, 'subid').then(({ subids }) => {
            this.setState({ isLoading: false,  subidValues: subids })
        });
    }

    handleSort(param) {
        const { sortParam, sortOrder } = this.state;

        if(sortParam === null) this.setState({ sortParam: param });
        else if(param === sortParam) this.setState({ sortOrder: sortOrder * -1 });
        else this.setState({ sortParam: param, sortOrder: 1 });
    }

    getGraph() {
        const { graph } = this.state;

        if(!graph.length) return;

        return <Graph data={graph} />;
    }

    render() {
        const { isLoading, affidValues, subidValues, params, paramsObj, report, total } = this.state;

        return (
            <Container loading={isLoading}>
                <Heading title="Pushapi V2"/>
                <Form onSubmit={this.handleSubmit} affidValues={affidValues} subidValues={subidValues}/>

                {this.getGraph()}

                <Table params={params} paramsObj={paramsObj} report={report} total={total} paramNames={PARAMS_NAME} NaNParams={NAN_PARAMS}/>
            </Container>
        );
    }
}

export default Pushapi;



// WEBPACK FOOTER //
// ./src/scenes/PushapiV2/index.js